import { html, css } from 'lit-element';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import { BaseElement } from './BaseElement';
import { API, EVENT_TYPES } from '../API';
import { Account } from '../Account';
import './PhysicianPortalEventTypes';
import './SurveyQuestions';
import './KneeProtocol';
import './PatientVideos';
import './DeliveryOptions';

const _api = Symbol();
const _account = Symbol();
const _statusHandler = Symbol();

class MyAccount extends BaseElement {
	constructor() {
		super();

		this.library.add(faKey);
		this[_statusHandler] = () => this.requestUpdate();
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				.container {
					
				}
				.container > * {
					margin-top: 1em;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get account() {
		return this[_account];
	}
	set account(v) {
		if(v !== null && !(v instanceof Account))
			throw new TypeError('account must be an instance of Account.');
		this[_account] = v;
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
		this.emit('get-account', { callback: account => this.account = account });

		this.api.on(EVENT_TYPES.EVENT_TYPE_LOGIN_STATUS, this[_statusHandler]);
		this.account.on('load', this[_statusHandler]);
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(null, this[_statusHandler]);
		this.account.off(null, this[_statusHandler]);

		this.api = null;
		this.account = null;
	}
	render() {
		return this.api.loggedIn ?
			html`
				<h4>My Account</h4>
				<p>
					Below is the information set for your Kinex physician account. If any of this information is incorrect, please contact our customer call center for corrections.
				</p>
				<p>
					<em>* If you do not see a value for Kinex Physician ID, you will not see any of your patients.  Please contact our <a href="mailto:techsupport@kinexmedical.com">Kinex Tech Support</a> department to correct this issue.</em>
				</p>
				<p><strong>Username</strong>: ${this.account.sAMAccountName}</p>
				<p><strong>Email Address</strong>: ${this.account.mail}</p>
				<p><strong>Patient Alerts Email Address</strong>: ${this.account.appServerAlertsEmail || 'Unknown'}</p>
				<p><strong>Kinex Physician ID</strong>: ${this.account.appServerDoctorId}</p>
				<a href="/change-password" class="button">
					<i class="icon fas fa-key"></i>
					Change Password
				</a>
				<div class="container">
					<pp-patient-videos></pp-patient-videos>
					<pp-knee-protocol></pp-knee-protocol>
					<pp-survey-questions></pp-survey-questions>
					<pp-event-types></pp-event-types>
					<pp-delivery-options></pp-delivery-options>
				</div>
			`:
			html`
				<h4>My Account is unavailable.</h4>
				<p>You are currently logged out</p>
			`;

	}
}

customElements.define('pp-my-account', MyAccount);